import { IconButton, Typography } from '@mui/material';
import Bullet from 'components/Bullet';
import React, { useEffect, useState } from 'react';
import { partial } from 'filesize';
import Icon from 'components/Icon';
import styles from './upload.module.scss';

const UploadedVideoInfo = ({
  file,
  path,
  length,
  height,
  width,
  name,
  removeFile
}: {
  file?: File;
  path?: string;
  length?: number;
  height?: number;
  width?: number;
  name?: string;
  removeFile?: () => void;
}) => {
  const [videoReolutionWidth, setvideoReolutionWidth] = useState('');
  const [videoReolutionheight, setvideoReolutionheight] = useState('');
  const [uploadFile, setUploadFile] = useState<{ src: string; size: number; name: string }>();
  const size = partial({ standard: 'jedec' });
  useEffect(() => {
    if (file) {
      setUploadFile({
        src: URL.createObjectURL(file),
        size: file.size,
        name: file.name
      });
    }
  }, [file]);

  useEffect(() => {
    if (path && length && name) {
      setUploadFile({
        src: path,
        size: length,
        name: name
      });
    }
  }, [path, length, height, width]);
  return (
    <div className={styles.uploadedVideoInfoWrapper}>
      <div className={styles.videoPreviewWrapper}>
        <video
          preload="metadata"
          onLoadedMetadata={e => {
            const vi = e.target as any;
            const width = vi.videoWidth;
            const height = vi.videoHeight;
            setvideoReolutionWidth(width);
            setvideoReolutionheight(height);
          }}
          autoPlay={false}
          muted
          controls={false}
          src={uploadFile?.src}
        />
      </div>
      <div className={styles.videoTextWrapper}>
        <div>
          <Typography variant="caption">
            {videoReolutionWidth}x{videoReolutionheight}px
          </Typography>
          <Bullet />
          <Typography variant="caption">{uploadFile ? size(uploadFile?.size) : ''}</Typography>
        </div>
        <div>
          <Typography variant="subtitle1">{uploadFile?.name}</Typography>
        </div>
      </div>

      {path && typeof path === 'string' ? (
        <IconButton
          onClick={removeFile}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            color: 'error',
            zIndex: 1,
            borderRadius: '4px',
            padding: '0'
          }}
        >
          <Icon name="close" size={'24'} />
        </IconButton>
      ) : null}
    </div>
  );
};

export default UploadedVideoInfo;
